import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {

  isExpanded = false;

  isInIframe: boolean = false;
  title: string = 'Employment 101';

  constructor(private route: ActivatedRoute, private _router: Router) { }

  ngOnInit() {
    this.inIframe();

    //console.log('url', this.route);
    //if (this.route.url.startsWith('/trainingprograms')) {
    //  this.title = "Training";
    //}

    this._router.events.subscribe((url: any) => {
      if (url instanceof NavigationEnd) {
        if (url.url.startsWith('/trainingprograms')) {
          this.title = 'Training';
        }
      }
    });
    //console.log(this._router.url);  // to print only path eg:"/login"
  }


  inIframe() {
    try {
      this.isInIframe = window.self !== window.top;
      //console.log("Am I in an Iframe? " + this.isInIframe);
    } catch (e) {
      this.isInIframe = true;
      //console.log("error deciding if Im in an Iframe. error: " + e);
    }
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
